export default "__VITE_ASSET__R8xQp_mr__"